import { useQuery } from '@apollo/client';
import { Col, Empty, Row } from 'antd';
import { GET_PLANS } from 'gql/plans/queries';
import { Plans as PlansType } from 'gql/plans/__generated__/Plans';
import { FC, memo, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import PlanItem from '../PlanItem';

const Plans: FC = () => {
  const [searchParams] = useSearchParams();
  const lang = useMemo(() => searchParams.get('lang'), [searchParams]);

  const { data } = useQuery<PlansType>(GET_PLANS, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    variables: {
      lang
    }
  });

  const results = data?.plans?.data || [];

  return (
    <div>
      {results.length ? (
        <Row gutter={[16, 16]} wrap>
          {results.map(item => (
            <Col sm={8} key={`plan-item-${item.id}`}>
              <PlanItem
                id={item.id}
                name={item.name}
                type={item.type as 1 | 2}
                duration={item.duration}
                description={item.description}
                price={item.price}
                features={item.features}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Row justify="center">
          <Empty />
        </Row>
      )}
    </div>
  );
};

export default memo(Plans);
